window.fwd = window.fwd || Object.create(null)

window.fwd.export = (key, value) => {
    window.fwd[key] = value
}

window.fwd.import = key => window.fwd[key]
